/**
 * Точка ветвления оформления — единственная на эту страницу.
 * Прежнее оформление лежит в `@/legacy` нетронутым, новое — в `@/modern`.
 * Логика и загрузка данных общие: их берём из прежнего модуля.
 */
import LegacyPage from '@/legacy/pages/venue/[venueName]/orders'
import ModernPage from '@/modern/pages/venue/[venueName]/orders'
import { useIsModernMenu } from '@/services/menu-design'

export { getStaticPaths, getStaticProps } from '@/legacy/pages/venue/[venueName]/orders'

export default function Route() {
  const isModernMenu = useIsModernMenu()

  return isModernMenu ? <ModernPage /> : <LegacyPage />
}
